// خدمات يُظهرها المسؤول أو يُخفيها لكل المستخدمين.
//
// الإخفاء صريح والظهور افتراض: إعداداتٌ محفوظة من نسخة سابقة لا تعرف
// هذه المفاتيح، فغيابُ المفتاح يعني «ظاهرة» — لا تختفي خدمةٌ لم يُخفِها أحد.

export const SERVICE_KEYS = ['mushaf', 'majlis', 'fatwa', 'studio'];

const FIELD = {
  mushaf: 'showMushaf',
  majlis: 'showMajlis',
  fatwa: 'showFatwa',
  studio: 'showStudio',
};

/** اسم حقل الإعداد لكل خدمة. */
export const serviceField = (service) => FIELD[service];

export const isServiceVisible = (siteSettings, service) =>
  siteSettings?.[FIELD[service]] !== false;
